import { render, staticRenderFns } from "./DurationWithUnit.vue?vue&type=template&id=ba74fe02&"
import script from "./DurationWithUnit.vue?vue&type=script&lang=js&"
export * from "./DurationWithUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports